import moment from 'moment-timezone';
import { takeLatest, put, call, select } from 'redux-saga/effects';
import {
  UPDATE_USER_PRODUCT_PRICE_REQUEST,
  UPDATE_USER_PRODUCT_PRICE_SUCCESS,
  UPDATE_USER_PRODUCT_REQUEST,
  UPDATE_USER_PRODUCT_SUCCESS,
  UPDATE_USER_PRODUCT_PRICE_FAILURE
} from "../types";

import { axiosInstance } from "../../utils";

function* updatePrice({ payload }) {
  try {
    const day = payload;
    const id = yield select(state => state.userProduct.product.id);
    const promo = yield select(state => state.promo);
    const { data: price } = yield call(axiosInstance.get, `products/price_with_tax/${id}?date=${moment(day).format('YYYY-MM-DD')}`);
    const { discountName, oldPrice, price: newPrice, tax, rate, total, oldTotal, serviceFee } = price;
    let priceObject;

    if (promo.status === 'success') {
      priceObject = {
        discountName: '',
        newPrice: oldPrice.toFixed(2),
        oldPrice: oldPrice.toFixed(2),
        tax,
        rate,
        total: oldTotal,
        oldTotal,
        serviceFee
      }
    } else {
      priceObject = {
        discountName,
        newPrice: newPrice.toFixed(2),
        oldPrice: oldPrice.toFixed(2),
        tax,
        rate,
        total,
        oldTotal,
        serviceFee
      };
    }
    yield put({ type: UPDATE_USER_PRODUCT_PRICE_SUCCESS, payload: priceObject });
  } catch (e) {
    yield put({ type: UPDATE_USER_PRODUCT_PRICE_FAILURE });
  }
}

export function* updateProduct({ payload }) {
  const name = payload;
  const date = yield select(state => state.userPreferences.date);
  const products = yield select(state => state.userProduct.hotel.products);

  const selectedProduct = products.find(availableProduct => availableProduct.name === name);
  const finalProduct = typeof selectedProduct !== 'undefined' ? selectedProduct : products[0];
  const userSession = localStorage.getItem('userSession');

  if (userSession) {
    const parsedUserSession = JSON.parse(userSession);
    localStorage.setItem('userSession', JSON.stringify({
      ...parsedUserSession,
      product: {
        ...parsedUserSession.product,
        ...finalProduct,
      },
    }))
  }

  yield put({ type: UPDATE_USER_PRODUCT_SUCCESS, payload: { product: finalProduct } });
  yield call(updatePrice, { payload: date });
}

export default function* saga() {
  yield takeLatest(UPDATE_USER_PRODUCT_PRICE_REQUEST, updatePrice);
  yield takeLatest(UPDATE_USER_PRODUCT_REQUEST, updateProduct);
}
